import React from 'react'
import '../views/css/Tags.scss'

class TagsDelete extends React.Component {

    deleteRequest() {
        const getToken = localStorage.getItem("token");
        const requestOptions = {
            method: "DELETE",
            mode: "cors",
            headers: {
                'Authorization': 'Bearer ' + getToken,
            },
        };

        fetch(`./wp-json/asd/tag/configs/delete/` + this.props.row.id, requestOptions)
            .then(response => response.json())
            .then(responseMessage => {
                if (responseMessage.hasOwnProperty('code')) {
                    this.props.handleErrorMsg(responseMessage.message)
                } else {
                    this.props.saveRequest()
                    this.props.handleErrorMsg('')
                    this.props.handleCloseModal()
                }
            });
    }

    render() {
        const deleteBtn = <button className='tags-save-button' variant="contained" onClick={() => this.deleteRequest()}>DELETE</button>
        return <React.Fragment>
            <div className='tags-delete-modal-message'>You are about to delete configuration <b>{this.props.row.name}</b>. This action cannot be undone.</div>
            <div className='tags-modal-buttons'>
                <span>{deleteBtn}</span>
                <span>{this.props.cancelBtn}</span>
            </div>
        </React.Fragment>
    }
}

export default TagsDelete
